import React from 'react';

const EngagementHeatmap = ({ data, loading }) => {
  const days = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
  const hours = ["00h", "04h", "08h", "12h", "16h", "20h"];

  const getIntensityColor = (value) => {
    if (value >= 80) return 'bg-success';
    if (value >= 60) return 'bg-primary';
    if (value >= 40) return 'bg-secondary';
    if (value >= 20) return 'bg-accent/50';
    return 'bg-muted';
  };

  const getIntensityOpacity = (value) => {
    return Math.max(0.2, value / 100);
  };

  if (loading) {
    return (
      <div className="w-full h-48 md:h-56 lg:h-64 bg-muted animate-pulse rounded-lg"></div>
    );
  }

  return (
    <div className="w-full overflow-x-auto">
      <div className="min-w-[320px] md:min-w-[600px]">
        <div className="flex gap-1 md:gap-2 mb-2 md:mb-3">
          <div className="w-12 md:w-16"></div>
          {hours?.map((hour) => (
            <div key={hour} className="flex-1 text-center">
              <span className="text-xs md:text-sm text-muted-foreground">{hour}</span>
            </div>
          ))}
        </div>

        <div className="space-y-1 md:space-y-2">
          {days?.map((day, dayIndex) => (
            <div key={day} className="flex gap-1 md:gap-2 items-center">
              <div className="w-12 md:w-16">
                <span className="text-xs md:text-sm font-medium text-foreground">{day}</span>
              </div>
              {data?.[dayIndex]?.map((value, hourIndex) => (
                <div
                  key={`${dayIndex}-${hourIndex}`}
                  className={`flex-1 h-8 md:h-10 lg:h-12 rounded transition-smooth hover:scale-105 cursor-pointer ${getIntensityColor(value)}`}
                  style={{ opacity: getIntensityOpacity(value) }}
                  title={`${day} ${hours?.[hourIndex]}: ${value}% d'engagement`}
                ></div>
              ))}
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mt-4 md:mt-6">
          <span className="text-xs md:text-sm text-muted-foreground">Faible</span>
          <div className="flex gap-1">
            {[20, 40, 60, 80, 100]?.map((value) => (
              <div
                key={value}
                className={`w-6 h-6 md:w-8 md:h-8 rounded ${getIntensityColor(value)}`}
                style={{ opacity: getIntensityOpacity(value) }}
              ></div>
            ))}
          </div>
          <span className="text-xs md:text-sm text-muted-foreground">Élevé</span>
        </div>
      </div>
    </div>
  );
};

export default EngagementHeatmap;